import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationWamService } from './authentication-wam.service';
import { UserService } from './user.service';
import { Http } from '@angular/http';

@Component({
  selector: 'app-authentication-wam',
  templateUrl: './authentication-wam.component.html',
  styleUrls: ['./authentication-wam.component.css'],
  providers: [ UserService]

})
export class AuthenticationWamComponent implements OnInit {

  decodeResp: any;
  samlResponse: any
  jsoneResponse: any;
  isAuthenticated: boolean = false;
  response = {
    Data: [] as { [key: string]: any }, Status: ''
  };
  Response: any;
  thirdUrl: string = null;
  fourthUrl: string = null;

  constructor(
    private _authservice: AuthenticationWamService,
    private route: ActivatedRoute,
    private router: Router,
    private _http: Http,
    private _user: UserService) { }


  ngOnInit() {
    //  debugger;
    if (this._user.getAuthToken()) {
      if (localStorage.getItem('state_url') != "") {
        this.router.parseUrl(localStorage.getItem('state_url'));
        this.isAuthenticated = true;
      }
      else {
        this.router.navigate(['dashboard']);
        this.isAuthenticated = true;
      }
    } else {

      if (!window.location.href.split('=')[1]) {
        this.isAuthenticated = false;
        this._authservice.userAuthenticationAPI();
      }

      this.samlResponse = window.location.href.split('=')[1]

      if (this.samlResponse)
        this.decodeResp = decodeURI(this.samlResponse)
      // console.log("Decoded :" +this.decodeResp);

      if (this.decodeResp)

        this.jsoneResponse = JSON.parse(this.decodeResp.slice(1, -1))
       // console.log("Jsoneresponse :" +this.jsoneResponse);

      setTimeout(() => {
        if ((this.jsoneResponse && this.jsoneResponse.Response.Status) === '') {
          this._authservice.userAuthenticationAPI();
          this.router.navigate(['dashboard']);

        } else {
          if ((this.jsoneResponse && this.jsoneResponse.Response.Status) === 'Failure') {
            this.router.navigate(['error']);
          }
          if ((this.jsoneResponse && this.jsoneResponse.Response.Status) === 'Success') {

            this.isAuthenticated = true;
            const resultToken = this.jsoneResponse.Response.Data.Result.token;


            this._user.sUsers = this.jsoneResponse.Response.Data.Result;
            this._user.setAuthToken(resultToken);
            this._user.setUser();
            // this.router.navigate(['dashboard']);
          if(this._user.sUsers.Roles.includes("NO_ROLE_USER"))
           {
            this.router.navigate(['norolepage']);//if user have no role 
          }
          else if(this._user.sUsers.Roles.includes("SCANIA_USER")||this._user.sUsers.Roles.includes("PURCHASER"))
           {
            this.router.navigate(['welcome']);//it will redirect them to two role mentioned albove
          }       
          else{
            this.router.navigate(['dashboard']);// else for any other role direct them to dashboard
          }         
          
        }
        }
      }, 0);
    }

  }

  logOut() {
    localStorage.clear();
}


}




// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/authentication-wam/authentication-wam.component.ts